import * as React from 'react';
import { DevicePropsType } from '../../types';
import { YwamShowcaseBrowserStyles } from './styles';

const YwamShowcaseBrowser : React.StatelessComponent<DevicePropsType> =
  ( props : DevicePropsType ) => {
    return (
      <YwamShowcaseBrowserStyles />
    );
  };

export default YwamShowcaseBrowser;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Device/devices/YwamShowcaseBrowser/YwamShowcaseBrowser.tsx